import { motion } from "framer-motion";
import { phoneLink, telegram } from "../data";
import heroCar from "../imgs/hero-car.png";

export default function Hero() {
  const container = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { staggerChildren: 0.2 } },
  };
  const item = {
    hidden: { y: 20, opacity: 0 },
    visible: { y: 0, opacity: 1 },
  };

  return (
    <section className="hero-section text-white">
      <div className="container py-5">
        <div className="row align-items-center">
          <motion.div variants={container} initial="hidden" animate="visible" className="col-lg-6">
            <motion.h1 variants={item} className="display-3 fw-bold mb-4">
              Выездной шиномонтаж <br /> и помощь на дороге <span className="text-danger">24/7</span>
            </motion.h1>
            <motion.p variants={item} className="lead mb-4 text-white">
              Приедем за 20–40 минут. Профессиональное оборудование, фиксированные цены.
            </motion.p>
            <motion.div variants={item} className="d-flex flex-wrap gap-3">
              <a href={phoneLink} className="btn btn-danger btn-lg rounded-pill px-5">Позвонить</a>
              {/* <a href={telegram} target="_blank" rel="nofollow" className="btn btn-outline-light btn-lg rounded-pill px-5">Telegram</a> */}
            </motion.div>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8 }}
            className="col-lg-6 d-none d-lg-block"
          >
            <img src={heroCar} alt="car" className="img-fluid" />
          </motion.div>
        </div>
      </div>
    </section>
  );
}